
const colorPalette = document.querySelectorAll('.choose-color');
var root = document.querySelector(':root')
const theme = document.querySelector('#theme');
const themeModal = document.querySelector('customize-theme');
















colorPalette.forEach(color => {
    color.addEventListener('click', () => {
        let primary;

        if(color.classList.contains('color-1')){
            primary = 252;
        }
        else if(color.classList.contains('color-2')){
            primary = 52;
        }

        root.style.setProperty('--primary-hue', primary);
    })
})